
import { defineComponent } from 'vue'

export default defineComponent({
  props: ['count', 'current']
})
